
export const mouseKeyboardAccessHelpers = () => {
  // Detect for Mouse vs. Keyboard events for accessibility helpers
  document.addEventListener('keydown', function(e){
    if (e.keyCode === 9) {
      document.body.classList.add('user-is-tabbing');
    }
  });

  document.addEventListener('mousedown', function(){
    document.body.classList.remove('user-is-tabbing');
  });
}



// WEBPACK FOOTER //
// ./src/utils/accessibility.js